import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { Store } from '@ngrx/store';

import { changeManyAnalysesStatus } from 'src/app/modules/analyses/store/analyses.actions';
import { translations } from 'src/i18n/translations';
import { AppViews } from 'src/app/shared/helpers/enums';
import { changeInvestmentCompaniesFlags } from 'src/app/modules/investment-companies/store/investment-companies.actions';
import { changeInvestmentsStatus } from 'src/app/modules/investments/store/investments.actions';
import { SharedService } from 'src/app/core/services/shared.service';
import { InvestmentStatus, PitchTypes, CustomerStatus } from 'src/app/shared/helpers/backendShortcuts';
import { changeManySubscriptionsStatus } from 'src/app/modules/subscriptions/store/subscriptions.actions';
import { changeManyQuestionsStatus } from 'src/app/modules/questions/store/questions.actions';
import { changePitchesFeaturedStatus } from 'src/app/modules/pitches/store/pitches.actions';
import { changePitchInvestmentsStatus, changePitchInvestmentsPaidStatus } from 'src/app/modules/pitches/store/transfer.actions';
import { changeUsersCustomerStatus } from 'src/app/modules/users/store/users.actions';

declare const UIkit: any;

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html'
})
export class ConfirmationModalComponent implements OnInit {
  @Input() item: string;
  @Input() numberOfSelectedItems: number;
  @Input() property: string;
  @Input() selectedItems: string[];
  @Input() type: string;
  @Input() variants: string[];
  @Input() view: string;
  @ViewChild('modal', { static: true }) modal: ElementRef;

  constructor(private sharedService: SharedService, private store: Store<any>) {}

  ngOnInit() {
    UIkit.modal('#showConfirmationDialog').show();

    UIkit.util.on('#showConfirmationDialog', 'hidden', this.sharedService.deleteModal.bind(this, this.modal));
  }

  modalHandler(selectedValue: string): void {
    let payload;
    let status: string;
    let shortStatus: string;

    switch (this.view) {
      case AppViews.Analyses:
        payload = {
          ids: this.selectedItems,
          muted: selectedValue === translations[this.sharedService.language].visible ? 'false' : 'true'
        };
        this.store.dispatch(changeManyAnalysesStatus({ payload }));
        break;

      case AppViews.InvestmentCompanies:
        payload = {
          ids: this.selectedItems,
          red: selectedValue === translations[this.sharedService.language].flagged ? 'true' : 'false'
        };
        this.store.dispatch(changeInvestmentCompaniesFlags({ payload }));
        break;

      case AppViews.Investments:
        status = Object.keys(translations[this.sharedService.language]).find(
          (key: string) => translations[this.sharedService.language][key] === selectedValue
        );
        shortStatus = status.charAt(0).toUpperCase() + status.slice(1);
        payload = {
          ids: this.selectedItems,
          status: InvestmentStatus[shortStatus]
        };
        this.store.dispatch(changeInvestmentsStatus({ payload }));
        break;

      case AppViews.Pitches:
        const type = Object.keys(translations[this.sharedService.language]).find(
          (key: string) => translations[this.sharedService.language][key] === selectedValue
        );
        const shortType = type
          .split(' ')
          .map((key: string) => key.charAt(0).toUpperCase() + key.slice(1))
          .join('');
        payload = {
          ids: this.selectedItems,
          visibility: PitchTypes[shortType]
        };
        this.store.dispatch(changePitchesFeaturedStatus({ payload }));
        break;

      case AppViews.Questions:
        payload = {
          ids: this.selectedItems,
          muted: selectedValue === translations[this.sharedService.language].visible ? 'false' : 'true'
        };
        this.store.dispatch(changeManyQuestionsStatus({ payload }));
        break;

      case AppViews.Subscriptions:
        payload = {
          ids: this.selectedItems,
          subscribed: selectedValue === translations[this.sharedService.language].subscribed ? 'true' : 'false'
        };
        this.store.dispatch(changeManySubscriptionsStatus({ payload }));
        break;

      case AppViews.Transfer:
        switch (this.type) {
          case 'paid':
            payload = {
              ids: this.selectedItems,
              paid: selectedValue === translations[this.sharedService.language].paid ? 'true' : 'false'
            };
            this.store.dispatch(changePitchInvestmentsPaidStatus({ payload }));
            break;
          case 'status':
            const selectedStatus = Object.keys(translations[this.sharedService.language]).find(
              (key: string) => translations[this.sharedService.language][key] === selectedValue
            );
            const selectedStatusShortcut = selectedStatus.charAt(0).toUpperCase() + selectedStatus.slice(1);
            payload = {
              ids: this.selectedItems,
              status: InvestmentStatus[selectedStatusShortcut]
            };
            this.store.dispatch(changePitchInvestmentsStatus({ payload }));
            break;
        }
        break;

      case AppViews.Users:
        status = Object.keys(translations[this.sharedService.language]).find((key: string) => {
          return translations[this.sharedService.language][key] === selectedValue;
        });
        shortStatus = status
          .split(' ')
          .map((key: string) => key.charAt(0).toUpperCase() + key.slice(1))
          .join('');
        payload = {
          ids: this.selectedItems,
          customer_status: CustomerStatus[shortStatus]
        };
        this.store.dispatch(changeUsersCustomerStatus({ payload }));
        break;
    }
  }
}
